<div class="revert-container">
  <div class="revert-card">
    <div *ngIf="loading" class="loading-state">
      <div class="spinner-wrapper">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
      <h2>Processing Your Request</h2>
      <p>Please wait while we revert your email change...</p>
    </div>

    <div *ngIf="errorMessage" class="error-state">
      <svg viewBox="0 0 24 24" class="error-icon">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <h2>Error</h2>
      <p>{{ errorMessage }}</p>
      <a routerLink="/login" class="btn-link">Return to Login</a>
    </div>
  </div>
</div>
